import React from 'react';
import { Box, Typography, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useDashboard } from '../context/DashboardProvider';
import { useTheme } from '@mui/material/styles';

const FrequencySelector = () => {
  const { frequency, setFrequency } = useDashboard();
  const theme = useTheme();

  const handleChange = (event, newFrequency) => {
    if (newFrequency) {
      setFrequency(newFrequency);
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ marginTop: '15px', fontSize: theme.typography.datePicker }}>
        Select Frequency
      </Typography>
      <ToggleButtonGroup
        value={frequency}
        exclusive
        onChange={handleChange}
        aria-label="frequency"
        sx={{
          display: 'flex',
          border: `0px solid ${theme.palette.background.border}`, // 🔥 Grey border as per theme
          borderRadius: 0, // 🔥 Actual square corners
          '& .MuiToggleButton-root': {
            flexGrow: 1, // Equal button width
            borderRadius: 0, // 🔥 Square edges
            border: `1px solid rgba(255, 255, 255, 0.2)`, // 🔥 Thin grey borders
            fontSize: theme.typography.button.fontSize, // 🔥 Uses theme font size
            color: theme.palette.text.primary,
            textTransform: 'none', // 🔥 No uppercase transformation
            backgroundColor: 'transparent', // 🔥 Default transparent background
            '&:not(:last-of-type)': {
              borderRight: `0px solid ${theme.palette.background.border}`, // 🔥 Keeps separators thin and grey
            },
            '&.Mui-selected': {
              backgroundColor: theme.palette.background.hover, // 🔥 Themed purple selection
              color: theme.palette.text.primary, // 🔥 Maintain text color
              borderColor: 'rgba(255, 255, 255, 0.2)',
              border: `1px solid ${theme.palette.background.border}`, // 🔥 Ensures no thickness change
            },
            '&:hover': {
              backgroundColor: theme.palette.background.hover, // 🔥 Themed hover effect
            },
          },
        }}
      >
        <ToggleButton value="daily" aria-label="daily">
          Daily
        </ToggleButton>
        <ToggleButton value="weekly" aria-label="weekly">
          Weekly
        </ToggleButton>
        <ToggleButton value="monthly" aria-label="monthly">
          Monthly
        </ToggleButton>
        <ToggleButton value="yearly" aria-label="yearly">
          Yearly
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default FrequencySelector;
